"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames, responsiveClassNames, responsivePropDependency } from "../../utilities/props.js";
import { useFormControl } from "../FormControl/index.js";
import Text from "../Text/index.js";
import useElementId from "../../hooks/useElementId.js";
import s from "./Switch.module.css";
const Switch = (props) => {
    const { children, name, checked, size = "medium", reversed, defaultChecked, onChange, onFocus, onBlur, className, attributes, } = props;
    const rootClassNames = classNames(s.root, size && responsiveClassNames(s, "--size", size), reversed && s["--reversed"], className);
    const formControl = useFormControl();
    const id = useElementId(formControl?.attributes.id || props.id || props.inputAttributes?.id);
    const inputAttributes = { ...props.inputAttributes, ...formControl?.attributes };
    const disabled = formControl?.disabled || props.disabled;
    const handleChange = (event) => {
        if (!onChange)
            return;
        onChange({
            name,
            event,
            checked: event.target.checked,
        });
    };
    return (_jsxs("label", { ...attributes, className: rootClassNames, children: [_jsx("input", { type: "checkbox", ...inputAttributes, className: s.input, name: name, checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: handleChange, onFocus: onFocus || inputAttributes?.onFocus, onBlur: onBlur || inputAttributes?.onBlur, id: id }), _jsx("span", { className: s.area, "aria-hidden": "true", children: _jsx("span", { className: s.thumb }) }), children && (_jsx(Text, { variant: responsivePropDependency(size, (value) => {
                    if (value === "large")
                        return "body-2";
                    if (value === "medium")
                        return "body-3";
                    return "caption-1";
                }), weight: "medium", color: disabled ? "disabled" : undefined, children: children }))] }));
};
Switch.displayName = "Switch";
export default Switch;
